import { gql } from "@apollo/client";

export const GET_USER_PAYMENTS = gql`
  query getPayments($pagination: Pagination) {
    getUserPayments(pagination: $pagination) {
      cardType
      depositAmount
      depositDate
      paymentOption
      internalId
    }
  }
`;

export const CONFIRM_INVOICE_PAYMENT = gql`
  mutation confirmInvoice(
    $userId: Int
    $invoiceId: Int
    $amount: Float
    $isBonus: Boolean
  ) {
    confirmInvoice(
      userId: $userId
      invoiceId: $invoiceId
      amount: $amount
      isBonus: $isBonus
    ) {
      balance
    }
  }
`;
